export default __webpack_public_path__ + "static/turkish_frame_account_bg-f4a5c2595cdda9c9356b5f385987335c.png";